const liveURL = 'https://mrb-server.onrender.com'
const testURL = 'http://localhost:5000'

export const apiURL = liveURL;